import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import LoginSingupLayout from '../../components/loginSingupLayout';
import {
  Button,
  Input,
  Label,
  Title,
  FormField,
  ErrorMessage,
} from './styles';
import { requestPasswordReset, ForgotPasswordAppDispatch } from '../../modules/forgotPassword';
import { RootState } from '../../store';
import AlertPopup from '../../components/common/AlertPopup';

const schema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Email is required'),
});

const ForgotPasswordPage: React.FC = () => {
  const dispatch = useDispatch<ForgotPasswordAppDispatch>();
  const { isLoading, error, success } = useSelector((state: RootState) => state.forgotPassword);
  const [alert, setAlert] = useState<{ message: string, severity: 'success' | 'error' } | null>(null);

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = (data: any) => {
    dispatch(requestPasswordReset(data.email));
  };

  useEffect(() => {
    if (success) {
      setAlert({ message: 'Password reset link sent to your email', severity: 'success' });
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      setAlert({ message: error, severity: 'error' });
    }
  }, [error]);

  return (
    <LoginSingupLayout>
      {alert && <AlertPopup message={alert.message} severity={alert.severity} open={!!alert} onClose={() => setAlert(null)} />}
      <Title>Forgot Password</Title>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormField>
          <Label htmlFor="email">Email*</Label>
          <Input {...register('email')} id="email" type="email" placeholder="name@email.com" />
          {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
        </FormField>
        <Button type="submit" disabled={isLoading}>{isLoading ? 'Sending...' : 'Submit'}</Button>
      </form>
    </LoginSingupLayout>
  );
};

export default ForgotPasswordPage;
